"use client";
import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import LottieFileInPage from "../../lib/lottie-files/LottieFileInPage";
import SvgHomePage from "../../lib/lottie-files/SvgHomePage";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  q: string;
}
const SearchNoResult: React.FC<Props> = ({ q }) => {
  const t = useTranslation();
  const router = useRouter();
  return (
    <LottieFileInPage
      lottieFileType={LottieFileTypes.no_result}
      title={t.no_results}
      text={`${t.sorry_no_result_related_to}: "${q}"`}
      button={{
        onClick: () => router.push("/"),
        content: (
          <>
            <SvgHomePage />
            {t.go_to_home_page}
          </>
        ),
      }}
    />
  );
};

export default SearchNoResult;
